<template>
  <v-layout align-center justify-space-between row wrap>
    <v-flex xs12 md6 lg6 xl6>

      <v-text-field
          class="form-field"
          v-model="requestId"
          label="Request ID"
          required
          disabled
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md6 lg6 xl6>
      <v-select
          class="form-field"
          :items="$store.state.RequestStatus"
          label="Request Status"
          :value="requestStatus"
          @change="statusChanged"
      ></v-select>
    </v-flex>

<v-flex xs12 md6 lg6 xl6>
    <v-text-field
          class="form-field"
          v-model="editingName"
          label="Request Name"
          required
          @change="(value) => $emit('name', value)"
      ></v-text-field>
    </v-flex>

    <v-flex xs12 md6 lg6 xl6>
       <v-select
                :items="$store.state.vendors"
                label="Vendor"
                item-text="vendorName"
                item-value="_id"
                v-model="editingVendor"
            ></v-select>
    </v-flex>

    <v-flex xs12 md6 lg6 xl6>
      <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
              v-model="approvedDate"
              label="Approved Date"
              append-icon="event"
              readonly
              v-on="on"
              class="date-picker"
          ></v-text-field>
        </template>
        <v-date-picker v-model="approvedDate" @input="menu1 = false"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 md6 lg6 xl6>
      <v-text-field
          class="form-field"
          v-model="requester"
          label="Requestor"
          required
          readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md6 lg6 xl6>
      <v-text-field
          class="form-field"
          v-model="approvedBy"
          label="Approved By"
          required
          readonly
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md6 lg6 xl6>
      <v-select
          class="form-field"
          :items="$store.state.RequestType"
          label="Request Type"
          :value="requestType"
          @change="typeChanged"
      ></v-select>
    </v-flex>
    <v-flex xs12 md6 lg6 xl6 v-if="requestStatus === 'Submitted for Pricing'">
        <v-btn
            small
            color="success"
            @click="approve"
        >
          <v-icon>check_circle</v-icon>&nbsp; Approve</v-btn>
    </v-flex>
    <v-flex xs12 md6 lg6 xl6 v-if="requestStatus === 'New'">
        <v-btn
            small
            color="success"
            @click="submitForPricing"
        >
          <v-icon>check_circle</v-icon>&nbsp; Submit for Pricing</v-btn>
    </v-flex>
  </v-layout>
</template>
<style>
  .date-picker {
    margin-right: 15px !important;
    margin-left: 8px !important;
  }
</style>
<script>
  export default {
    data() {
      return {
        date: new Date().toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        editingName: undefined,
        editingVendor: undefined,
      }
    },
    props: [
      'requestType', 'approvedBy', 'requester',
      'approvedDate', 'requestDate', 'requestStatus',
      'requestId', 'name', 'vendor'],
    computed: {
      /*
      computedDateFormattedRequest () {
        return this.formatDate(this.requestDate)
      },
      computedDateFormattedApproved () {
        return this.formatDate(this.approvedDate)
      },*/
    },
    beforeUpdate() {
      if (!this.editingName) this.editingName = this.name;
      if (!this.editingVendor) this.editingVendor = this.vendor;
    },
    watch: {
      editingName: function(value) {
        this.$emit('data-changed', { name: value });
      },
      editingVendor: function(value) {
        this.$emit('data-changed', { vendor: value });
      }
    },
    methods: {
      /*
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      */
      approve() {
        this.$emit('approve');
      },
      submitForPricing() {
        this.$emit('submit-for-pricing');
      },
      statusChanged(value) {
        console.log('statusChanged:', value);
        this.$emit('data-changed', { requestStatus: value });
      },
      typeChanged(value) {
        console.log('typeChanged:', value);
        this.$emit('data-changed', { requestType: value });
      },
    }
  }
</script>
